import styles from './feature-idea-channel.module.less';
import Kanban from './kanban/kanban';

/* eslint-disable-next-line */
export interface FeatureIdeaChannelProps {}

export function FeatureIdeaChannel(props: FeatureIdeaChannelProps) {
  return (
    <div className={styles['container']}>
      <Kanban />
    </div>
  );
}

export default FeatureIdeaChannel;
